export default __webpack_public_path__ + "static/9-personenbus-mercedes-vito-wit-bert-jonk-21f12cc84710ce21c01d36b4ae129e38.jpg";